import { Col, Row, Skeleton } from 'antd';

type HomeSkeletonProps = {
  matches: boolean;
  spanSize: number;
};

export default function HomeSkeleton({ matches, spanSize }: HomeSkeletonProps) {
  return (
    <Row gutter={24} style={{ display: 'flex', justifyContent: 'center' }}>
      <Col span={spanSize} style={{ marginTop: 12, padding: matches ? 0 : 12 }}>
        {[0, 1, 2].map((section) => (
          <div
            key={section}
            style={{
              marginBottom: '1rem',
              background: 'rgb(41,40,40)',
              borderRadius: 10,
              padding: 12,
            }}
          >
            <Skeleton
              active
              title={{ width: 180 }}
              paragraph={false}
              style={{ marginBottom: 12 }}
            />
            <Row gutter={12}>
              {[0, 1, 2, 3].map((card) => (
                <Col span={12} key={card} style={{ padding: 4 }}>
                  <div
                    style={{
                      background: '#1a1a1d',
                      borderRadius: 10,
                      padding: 12,
                      minHeight: matches ? 72 : 56,
                    }}
                  >
                    <Skeleton
                      active
                      avatar={{ shape: 'square', size: 20 }}
                      title={{ width: '70%' }}
                      paragraph={false}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </Col>
    </Row>
  );
}
